import { render } from "./DonationTipButtons.vue?vue&type=template&id=1d3654b6&scoped=true"
import script from "./DonationTipButtons.vue?vue&type=script&lang=js"
export * from "./DonationTipButtons.vue?vue&type=script&lang=js"

import "./DonationTipButtons.vue?vue&type=style&index=0&id=1d3654b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3654b6"]])

export default __exports__
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle,QInput,QIcon,QChip,QBtnGroup,QBtn,QField,QHeader});
